export default "__VITE_ASSET__21870dc3__"